import { useState } from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import globals from '../../globals';

const PasswordFieldRegister = ({ labelName, idName, onChange, error, helperText, inputProps }) => {
    const [focused, setFocused] = useState(false);
    const [value, setValue] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    const handleChange = (e) => {
        if (onChange) {
            onChange(e);
        }
        setValue(e.target.value);
    }

    return (
        <TextField
            required
            id={idName}
            type={showPassword ? 'text' : 'password'}
            label={focused || value ? '' : labelName}
            variant="outlined"
            value={value}
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
            onChange={handleChange}
            size="medium"
            error={error}
            helperText={helperText}
            inputProps={{...inputProps, autoComplete: 'new-password'}}
            sx={{
                width: '100vh',
                borderRadius: 1,
                color: globals.colors.textColor,
                '& .MuiOutlinedInput-root': {
                    '& .MuiInputBase-input': {
                        backgroundColor: globals.colors.backgroundColor,
                    },
                    '& fieldset': {
                        borderColor: error ? 'error.main' : globals.colors.darkRed,
                    },
                    '&:hover fieldset': {
                        borderColor: error ? 'error.main' : globals.colors.darkRed,
                    },
                    '&.Mui-focused fieldset': {
                        borderColor: error ? 'error.main' : globals.colors.darkRed,
                    },
                },
            }}
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                            onClick={() => setShowPassword((prev) => !prev)}
                            edge="end"
                        >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                    </InputAdornment>
                ),
            }}
        />
    );
};

export default PasswordFieldRegister;
